import React from 'react';
import { View } from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphLatestPointsOfView = ({ id }) => (
  <div id={id} className="ParagraphLatestPointsOfView">
    <View
      className="ParagraphLatestPointsOfView__view"
      id="latest_points_of_view"
      display="block_1"
      withProvider
    />
  </div>
);

export default ParagraphLatestPointsOfView;
